const onArrowUp =
  (handler) =>
  (e, ...args) => {
    if (e.key === 'ArrowUp') {
      handler(e, ...args);
    }
  };

export default onArrowUp;
